import {
  IAtlasObjectDetailResponse,
  IGetAtlasObjectDetailParams,
  atlasObjectRefKey,
} from '@common/interfaces/atlasObjects'
import { IActionWithParams } from '../apiMiddleware'
import * as actions from './actions'

export interface IAtlasPreviewState {
  target: actions.IAtlasPreviewTarget | null
  detail: IAtlasObjectDetailResponse | null
  isLoading: boolean
  hasError: boolean
  latestRequestId: number | null
}

const initialState: IAtlasPreviewState = {
  target: null,
  detail: null,
  isLoading: false,
  hasError: false,
  latestRequestId: null,
}

const isLatestRequest = (state: IAtlasPreviewState, requestId: number | undefined): boolean =>
  requestId !== undefined && requestId === state.latestRequestId

const isCurrentTarget = (
  state: IAtlasPreviewState,
  params: IGetAtlasObjectDetailParams | undefined,
): boolean =>
  !!state.target && !!params && atlasObjectRefKey(state.target.ref) === atlasObjectRefKey(params)

const atlasPreview = (
  state: IAtlasPreviewState = initialState,
  action: IActionWithParams<IGetAtlasObjectDetailParams>,
): IAtlasPreviewState => {
  switch (action.type) {
    case actions.OPEN_ATLAS_PREVIEW: {
      const target = action.data as actions.IAtlasPreviewTarget
      const isSameRecord =
        !!state.target && atlasObjectRefKey(state.target.ref) === atlasObjectRefKey(target.ref)
      return isSameRecord ? { ...state, target } : { ...initialState, target }
    }

    case actions.CLOSE_ATLAS_PREVIEW:
      return initialState

    case actions.GET_OBJECT_DETAIL_REQUEST:
      return isCurrentTarget(state, action.params)
        ? { ...state, isLoading: true, hasError: false, latestRequestId: action.requestId ?? null }
        : state

    case actions.GET_OBJECT_DETAIL_SUCCESS:
      return isLatestRequest(state, action.requestId)
        ? { ...state, detail: action.data as IAtlasObjectDetailResponse, isLoading: false }
        : state

    case actions.GET_OBJECT_DETAIL_FAILURE:
      return isLatestRequest(state, action.requestId)
        ? { ...state, isLoading: false, hasError: true }
        : state

    default:
      return state
  }
}

export default atlasPreview
